import { render, staticRenderFns } from "./SaleTransactionDetails.vue?vue&type=template&id=fa30a342&"
import script from "./SaleTransactionDetails.vue?vue&type=script&lang=js&"
export * from "./SaleTransactionDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports